import { ParcoursStubPage } from '../../../components/parcours/ParcoursStubPage';
import { getParcoursStub } from '../../../config/parcours-particuliers';

export default function MonAccompagnateurRenovPage() {
  const parcours = getParcoursStub('mon-accompagnateur-renov');
  if (!parcours) return null;
  return <ParcoursStubPage parcours={parcours} />;
}
